import { useContext, useState } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import { Routes } from '../../constants/RouteConstants';
import authContext from '../../context/authContext';
import useMakeRequest from '../../utils/ApiHelper';
import BottomMenu from './BottomMenu';
import PageLoader from './PageLoader';

const PrivateLayout = () => {

  const navigate = useNavigate();
  const { pathname } = useLocation();
  const profile: any = useContext(authContext);
  const hideLayoutPath = [Routes?.ManageProfile];
  const [showPageLoader, setShowPageLoader] = useState(false);


  return (
    <>
      {showPageLoader ? <PageLoader /> : ''}
      <div className={`inner-data-wrap ${hideLayoutPath.includes(pathname) ? 'no-bottom-bar' : ''}`}>
        <Outlet />
      </div>
      {
        !hideLayoutPath.includes(pathname) && <BottomMenu />
      }
    </>
  )
}

export default PrivateLayout